import { CommonAction } from "../../../login/redux/types";
import DealPaymentTypes, { DealPaymentState } from "./types";

const initialState: DealPaymentState = {
    payment: undefined,
    loading: false
}

export const dealPayemntReducer = (state = initialState, action: CommonAction): DealPaymentState => {
    switch (action.type) {
        case DealPaymentTypes.DEAL_REPAYMENT_REQ: 
            return {
                ...state,
                loading: true,
                payment: undefined
            }
        case DealPaymentTypes.SET_DEAL_REPAYMENT_REQ:
            return {
                ...state,
                loading: false,
                payment: action.payload
            }
        default:
            return state;
    }
}

export default dealPayemntReducer;